import React, { Fragment } from "react"
import "./Overview.scss"
import ComplianceCardWithData from "../../components/ComplianceCard/ComplianceCardWithData"
import LineGraphCardWithData from "../../components/LineGraphCard/LineGraphCardWithData"
import SecondaryNavWithData from "../../components/SecondaryNav/SecondaryNavWithData"
import NeedsABoostCard from "../../components/NeedsABoostCard"
import TopPerformersCard from "../../components/TopPerformersCard"
import { Container, Row, Col } from "reactstrap"
import ResourceBannerWithData from "../../components/ResourceBanner/ResourceBannerWithData"
import BsrComplianceToggleWithStore from "../../components/BsrComplianceToggle/BsrComplianceToggleWithStore"
import PropTypes from "prop-types"
import ComplianceTableWithControlsWithData from "../../components/ComplianceTableWithControls/ComplianceTableWithControlsWithData"
import LongestGapCardsWithData from "../../components/LongestGapCards/LongestGapCardsWithData"

const renderMainOverview = ({ match: { params } }) => (
  <Fragment>
    <Row>
      <Col lg="3" md="12" xs="12">
        <ComplianceCardWithData
          entityId={params.entityId}
          entityType={params.entityType}
        />
      </Col>
      <Col lg="9" md="12">
        <Row>
          <Col lg="12" sm="12">
            <LongestGapCardsWithData
              entityId={params.entityId}
              entityType={params.entityType}
            />
          </Col>
        </Row>
        <Col md="12" xs="12">
          <LineGraphCardWithData
            entityId={params.entityId}
            entityType={params.entityType}
          />
        </Col>
      </Col>
    </Row>
    <Row>
      <Col md="6" xs="12">
        <TopPerformersCard
          entityId={params.entityId}
          entityType={params.entityType}
        />
      </Col>
      <Col md="6" xs="12">
        <NeedsABoostCard
          entityId={params.entityId}
          entityType={params.entityType}
        />
      </Col>
    </Row>
  </Fragment>
)

const renderChildEntityOverview = ({ match: { params } }) => (
  <React.Fragment>
    <Row>
      <Col lg="3" md="12" xs="12">
        <ComplianceCardWithData
          entityId={params.entityId}
          entityType={params.entityType}
        />
      </Col>
      <Col lg="9" md="12">
        <Row>
          {/* placeholder for cards that will be the same visuals with content for applicable entity (unit, department, etc) */}
          <Col lg="12" sm="12">
            <LongestGapCardsWithData
              entityId={params.entityId}
              entityType={params.entityType}
            />
          </Col>
        </Row>
        <Col md="12" xs="12">
          <LineGraphCardWithData
            entityId={params.entityId}
            entityType={params.entityType}
          />
        </Col>
      </Col>
    </Row>
    <Row>
      <Col md="12" xs="12">
        <ComplianceTableWithControlsWithData simpleDisplay={true} />
      </Col>
    </Row>
  </React.Fragment>
)

const Byline = ({ text }) => {
  return (
    <div className="byline">
      <div className="celebration-text-container">{text}</div>
      <BsrComplianceToggleWithStore />{" "}
    </div>
  )
}

Byline.propTypes = {
  text: PropTypes.string.isRequired,
}

export { Byline }

const Overview = props => (
  <div className="Overview content">
    <ResourceBannerWithData />
    {props.isNestedEntity && <SecondaryNavWithData />}
    <Container fluid>
      <Row className="justify-content-md-center">
        <Col xs="12" />
        <Col lg="11">
          <Byline
            text={
              props.isNestedEntity
                ? ""
                : "When was the last time you celebrated a compliance achievement? Celebrate one today!"
            }
          />
        </Col>
        <Col lg="11" xs="12">
          {props.isNestedEntity
            ? renderChildEntityOverview(props)
            : renderMainOverview(props)}
        </Col>
        <Col xs="12" />
      </Row>
    </Container>
  </div>
)

Overview.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      entityId: PropTypes.string.isRequired,
      users: PropTypes.string,
      entityType: PropTypes.oneOf(["facility", "department", "unit"])
        .isRequired,
    }).isRequired,
  }).isRequired,
  isNestedEntity: PropTypes.bool,
}

renderChildEntityOverview.propTypes = {
  match: Overview.propTypes.match,
}

renderMainOverview.propTypes = {
  match: Overview.propTypes.match,
}

export default Overview
